import axios from 'axios';
import { getSession } from 'next-auth/react';

const SERVER_ROUTER = process.env.NEXT_PUBLIC_SERVER_URL!;
const DEFAULT_ROUTER = process.env.NEXT_PUBLIC_DEFAULT_ROUTE!;

const instance = axios.create({
  baseURL: SERVER_ROUTER + DEFAULT_ROUTER,
  withCredentials: process.env.NODE_ENV === 'production' ? true : false,
});

const ACCESS_TOKEN_URI = '/api/auth/access-token';
const EXPIRED_TOKEN = 'TokenExpire';
const ACCESS_TOKEN = 'accessToken';

instance.interceptors.request.use(
  async (config) => {
    if (config.headers.requiredToken) {
      let accessToken = window.localStorage.getItem(ACCESS_TOKEN);

      const {
        data: { accessToken: _accessToken },
      } = await axios.get(ACCESS_TOKEN_URI);

      accessToken = _accessToken;
      window.localStorage.setItem(ACCESS_TOKEN, _accessToken);

      config.headers['Token'] = accessToken;
    }
    if (process.env.NODE_ENV === 'development') {
      const session = await getSession();
      if (session) {
        config.headers['Authorization'] = session.accessToken;
      }
      return config;
    }
    if (config.headers.notInterceptor) return config;
    if (!window || !window.localStorage) {
      return config;
    }

    const lang = window.localStorage.getItem('lang') || 'th';

    config.headers['Lang'] = lang;
    return config;
  },
  (error) => {
    console.error(error);
  },
);

instance.interceptors.response.use(
  (config) => config,
  async (error) => {
    if (
      error.response?.data.message &&
      error.response.data.message === EXPIRED_TOKEN
    ) {
      const {
        data: { accessToken },
      } = await axios.get(ACCESS_TOKEN_URI);
      window.localStorage.setItem(ACCESS_TOKEN, accessToken);
      error.response.config.headers['Token'] = accessToken;
      await instance(error.response.config);
    }
  },
);

export default instance;
